












import Vue from 'vue';
import BaseEditorText from '../base/BaseEditorText.vue';

export default Vue.extend({
  name: 'BlockEditorHeading3',
  components: {
    BaseEditorText,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      styling: { fontSize: '1.6rem', fontWeight: '300' },
    };
  },
});
